<template>
  <div class="space-y-6">
    <OnboardingChecklist data-tour="onboarding-checklist" />

    <section v-if="helpTutorials.length" aria-label="Help & tutorials">
      <h2 class="font-semibold">Help &amp; tutorials</h2>
      <ul>
        <li v-for="t in helpTutorials" :key="t.slug">
          <button type="button" class="underline" @click="active = t">{{ t.title }}</button>
        </li>
      </ul>
    </section>

    <TutorialModal :tutorial="active" @close="active = null" />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import OnboardingChecklist from "/@/components/onboarding/OnboardingChecklist.vue";
import TutorialModal from "/@/components/onboarding/TutorialModal.vue";
import { visibleTutorials, Tutorial } from "/@/config/tutorials";
import useTour from "/@/composables/useTour";

export default defineComponent({
  name: "Dashboard",
  components: { OnboardingChecklist, TutorialModal },
  setup() {
    const helpTutorials = visibleTutorials();
    const active = ref<Tutorial | null>(null);
    const { offerTourOnce } = useTour();
    let cancelTourOffer: () => void = () => {};
    onMounted(() => {
      cancelTourOffer = offerTourOnce();
    });
    // Cancel a pending offer if the user navigates away within the delay —
    // otherwise the tour would start on whatever page comes next.
    onUnmounted(() => cancelTourOffer());
    return { helpTutorials, active };
  },
});
</script>

<style lang="postcss" scoped></style>
